var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loaded)?_c('download-csv',{staticClass:"btn btn-primary",attrs:{"labels":_vm.header,"data":_vm.rows,"delimiter":";","name":"vitalog.csv"}},[_vm._v(" Export CSV ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }